export default __webpack_public_path__ + "static/media/014-tennis.cb688069.svg";